/*
 * @Author: 屈 乐佳 lj.qu@foundtec.com
 * @Date: 2023-04-27 17:19:03
 * @LastEditors: 屈 乐佳 lj.qu@foundtec.com
 * @LastEditTime: 2023-11-09 15:22:26
 * @FilePath: \video-monitor-mobile\src\store\userindex.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { ref } from "vue";
import { defineStore } from "pinia";

const rootId = window.VITE_APP_AREA_ROOT || import.meta.env.VITE_APP_AREA_ROOT;
export const userIndex = defineStore("userindex", () => {
  const menuShow = ref(false);
  //整个树 用来保存 列表和地图的整个树  每次点击从整个树中截取 初始化只进行一次初始化
  const mapType = ref("heat");
  const type = ref<string>("list"); //表明展示列表还是地图
  const auth = ref<number>(1); //标明当前用户的访问权限

  const areaList = ref<Array<any>>([]);
  const zoneArr = ref<Array<any>>([]);
  const activeNamesArr = ref<Array<Array<string>>>([[]]); //用来控制每一层子组件展开状态
  const activeNames = ref([]);
  const activeZone = ref<string>("");
  const currentIsc = ref<string>("");
  const tencentMap = ref<{ point: any; activeId: string; zoom: number; activeName: string; change: boolean }>({
    point: "",
    activeId: "",
    zoom: 10,
    activeName: "",
    change: false
  });
  const setTencentMap = (obj: { point: any; activeId: string; zoom: number; activeName: string; change: boolean }): void => {
    tencentMap.value = { ...obj };
  };
  const initActiveNamesArr = () => {
    activeNamesArr.value.map((el) => {
      console.log(el, "答应的");
      el = [];
    });
  };
  const changeType = (str: string) => {
    type.value = str;
  };

  const clearData = () => {
    areaList.value = [];
    activeNamesArr.value = [[]];
  };
  const setMenuShow = (boolean: boolean): void => {
    menuShow.value = boolean;
    if (!boolean) {
      type.value = "list";
      mapType.value = "heat";
      tencentMap.value = {
        point: "",
        activeId: "",
        zoom: 10,
        activeName: "",
        change: false
      };
    }
  };
  const setCurrentIsc = (val: string) => {
    currentIsc.value = val;
  };
  return {
    areaList,
    type,
    auth,
    activeNamesArr,
    currentIsc,
    activeZone,
    zoneArr,
    activeNames,
    menuShow,
    tencentMap,
    mapType,
    setTencentMap,
    setMenuShow,
    initActiveNamesArr,
    changeType,
    clearData,
    setCurrentIsc
  };
});
